import { Create, Delete, SettingsBackupRestore } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import ConfirmAlert from "../../utils/ConfirmAlert";
import CustomMuiSwitch from "../../utils/customMuiSwicth/CustomMuiSwitch";
import TopHeading from "../../utils/TopHeading/TopHeading";
import CustomTable from "../../views/CustomTable/CustomTable";
import AnimatedPage from "../animatedPage/AnimatedPage";
import Hoc from "../HOC/Hoc";

const AssignedFeatures = (props) => {
  const {
    data,
    loading,
    page,
    setPage,
    pageCount,
    handleOpenModal,
    handleCloseModal,
    openModal,
    setSuccess,
    setError,
    openEditModal,
    handleOpenEditModal,
    handleCloseEditModal,
    setAlert,
    alert,
    closeAlert,
    showPagination,
    setShowPagination,
    hidePagination,
  } = props;
  const [assignedFeatures, setassignedFeatures] = useState([]);
  const [editId, setEditId] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  useEffect(() => {
    if (data) {
      setassignedFeatures(data);
    }
    return () => {
      setassignedFeatures(data);
    };
  }, [data]);

  const rows = [];
  const labels = ["Name", "Status"];
  assignedFeatures &&
    assignedFeatures.length > 0 &&
    assignedFeatures.map((item) =>
      rows.push([
        item.feature,
        <CustomMuiSwitch checked={item.isActive} />,
      ])
    );
  return (
    <>
    <AnimatedPage>
      <TopHeading showButton={false} heading="Features" />
      <CustomTable labels={labels} data={rows} pageLoading={loading} />
    </AnimatedPage>
    </>
  );
};

export const EnhancedAssignedFeatures = Hoc(AssignedFeatures, { name: "assigned-features" });
